/**
 * 检查对应的插件方法是否可用
 * @param {} name
 */
export function canUse(name) {
  return !!(window.zzcjsbridge && window.zzcjsbridge[name]);
}

/**
 * GrowingIO统计事件埋点
 * @param {String} action 埋点事件标识符、页面级变量上报事件(PageVariable)、转化变量(Evariable)、登录用户id+变量(PeopleVariable)
 * @param {*} dataStr 自定义上报字段
 */
export function growingIoPoint({ action = '', dataStr }) {
  let param = dataStr;
  if (param instanceof Object) {
    param = JSON.stringify(param);
  }
  return new Promise((resolve) => {
    if (!canUse('growingIO')) {
      return;
    }
    window.zzc.call('growingIO', {
      action,
      dataStr: param,
      success: (respone) => {
        resolve(respone);
      },
    });
  });
}

/**
* 埋点上报
* @param {*} event 事件标识 view/click
* @param {*} log 埋点配置
* @returns
*/
function doTrack(event, log) {
  // 转化变量上报 （event === 'click'为了避免曝光也会触发转化变量上报）
  if (event === 'click' && log.evar && log.data) {
    window.gio('evar.set', log.data);
    return;
  }
  // 事件变量上报
  if (log[event] && log.data) window.gio('track', log[event], log.data);
}

/**
 * 多次上报埋点事件并剔除gio数据源
 * @param {String} event 事件标识
 * @param {{ gioList: [{ view: 'xx', click: 'xx', evar: false, data: {} }] }} data 埋点数据
 * v1.1 gioList支持传对象（单个事件场景）
 * v1.2 gioList支持选择上报事件
 */
export const gioTrackByList = (event, data) => {
  const dataCopy = data;
  const { gioList } = dataCopy;
  if (!gioList) return dataCopy;
  if (gioList instanceof Array) {
    gioList.forEach((log) => {
      doTrack(event, log);
    });
  } else {
    doTrack(event, gioList);
  }
  delete dataCopy.gioList;

  return dataCopy;
};
